<template>
  <div class="pg-image">
    <div v-if="imageList.length > 0">
      <ElImage
        :style="styles"
        style="margin-right: 10px"
        v-for="img in imageUrlList"
        :key="img"
        v-bind="$attrs"
        :src="img"
        placeholder="暂无"
        :preview-src-list="imageUrlList"
      >
      </ElImage>
    </div>
    <div v-else>暂无图片</div>
  </div>
</template>
<script>
import { Image } from 'element-ui'
export default {
  inheritAttrs: false,
  components: {
    [Image.name]: Image,
  },
}
</script>
<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: [String, Array],
  multiple: { type: Boolean, default: false },
  valueIsObj: { type: Boolean, default: false },
  styles: {
    type: Object,
    default: () => ({
      width: '100px',
      height: '100px',
    }),
  },
})

const imageList = computed(() => {
  if (!props.value) return []
  if (props.valueIsObj) {
    return props.multiple ? props.value : [props.value]
  } else {
    let tempVal = props.multiple
      ? Array.isArray(props.value)
        ? props.value
        : props.value.split(',')
      : [props.value]
    return tempVal.map((item) => {
      const tmp = item.split('/')
      const len = tmp.length

      const name = tmp[len - 1]
      return { url: item, name }
    })
  }
})

const imageUrlList = computed(() => {
  if (!props.value) return []
  if (props.valueIsObj) {
    return props.multiple ? props.value.map((im) => im.url) : [props.value.url]
  } else {
    return props.multiple ? props.value : [props.value]
  }
})
</script>
<style lang="scss">
@import '../style/image.scss';
</style>
